"use client";

import React from "react";
import { usePathname } from "next/navigation";
import parser from "html-react-parser";

const GGSBreadcrumbs = ({ menu, text, title, isFrench, draftPreview }) => {
  let pathName = usePathname().substring(1);
  if (pathName.startsWith("ggs/")) {
    pathName = pathName.substring(4);
  }
  const pathItems = pathName.split("/");
  const pathLinkElements = (
    delimiter = " / ",
    pathHtmlArray = [],
    pathArray = []
  ) => {
    let currentMenu = menu;

    pathItems.map((item, index) => {
      if (index === pathItems.length - 1) {
        pathHtmlArray.push(
          `${delimiter} <span className="CMSBreadCrumbsCurrentItem" key=${index}>${
            !!text ? text : title
          }</span>`
        );
      } else {
        const menuItem = currentMenu?.find(
          (menu) =>
            menu.attributes?.slug?.toLowerCase() === item.toLowerCase() ||
            menu.attributes?.slug?.substring(4).toLowerCase() ===
              item.toLowerCase()
        );
        if (!!menuItem) {
          currentMenu = menuItem.attributes?.children?.data;
        }
        if (
          menuItem?.attributes?.ggspage_relation !== null ||
          (menuItem?.attributes?.url !== null &&
            menuItem?.attributes?.url !== "")
        ) {
          pathArray.push(menuItem?.attributes?.slug);
          pathHtmlArray.push(
            `${delimiter} <a href='${
              draftPreview
                ? "#"
                : menuItem?.attributes?.url !== null &&
                    menuItem?.attributes?.url !== ""
                  ? menuItem?.attributes?.url
                  : "/" + pathArray.join("/")
            }${
              isFrench ? "?lang=fr-CA" : ""
            }' className="CMSBreadCrumbsLink" key=${index}>${
              draftPreview ? "Draft/Preview" : menuItem?.attributes?.title
            }</a>`
          );
        } else {
          pathArray.push(menuItem?.attributes?.slug);
        }
      }
    });
    return pathHtmlArray.join("");
  };

  return (
    <div className="ggs-breadcrumbs">
      <nav className="tps-breadcrumbs no-print">
        <a
          href={`/ggs${isFrench ? "?lang=fr-CA" : ""}`}
          className="tps-breadcrumbs-link"
          title="Back to Home"
        >
          <span className="sr-only">Back to Home</span>
          <i className="fal fa-home fa-solid" aria-hidden="true"></i>
        </a>
        {parser(pathLinkElements())}
      </nav>
    </div>
  );
};

export default GGSBreadcrumbs;
